import {
  UPDATE_MANAGER_EMPLOYEE_SUCCESS,
  DELETE_MANAGER_EMPLOYEE_SUCCESS,
  ADD_MANAGER_EMPLOYEE_SUCCESS
} from "../Constants";

const initialState = {
  message: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MANAGER_EMPLOYEE_SUCCESS:
      return {
        type: "Employees updated Successfully",
        message: action.data
      };
    case DELETE_MANAGER_EMPLOYEE_SUCCESS:
      return {
        type: "Employee Deleted Successfully",
        message: action.data
      };
    case ADD_MANAGER_EMPLOYEE_SUCCESS:
      return {
        type: "Employee added Successfully",
        message: action.data
      };
    default:
      return state;
  }
};
